import React from "react";
import CreateDeploymentForm from "../pages/application-summary-page/CreateDeploymentForm";
import UpdateDeploymentForm from "../pages/application-summary-page/UpdateDeploymentForm";
import { UpdateDeploymentProps } from "./DeploymentDetails";
import Dialog from "legacy-components/dialog/Dialog";
import { Box, makeStyles, createStyles } from "@material-ui/core";

const useStyles = makeStyles(() => 
  createStyles({
    dialogContent: {
      padding: "5px 2px 5px 2px",
    }
  })
);



interface CreateDeploymentDialogProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  basePath: string;
  resourceAppId: string;
  version: string;
  availableRegions: Array<{ key: string; value: string; }>;
  updateDeployment?: UpdateDeploymentProps
}

export const CreateDeploymentDialog: React.FC<CreateDeploymentDialogProps> = ({
  open,
  onClose,
  onSuccess,
  basePath,
  resourceAppId,
  version,
  availableRegions,
  updateDeployment
}) => {
  const classes = useStyles();
  
  return (
    <Dialog
      open={open}
      title={updateDeployment?.isUpdate ? "Edit Deployment" : "Add New Deployment"}
      onClose={onClose}
    >
      <Box className={classes.dialogContent}>
        {updateDeployment?.isUpdate ? <UpdateDeploymentForm
          onCancel={onClose}
          onSuccess={onSuccess}
          basePath={basePath}
          version={version}
          availableRegions={availableRegions}
          updateDeploymentInitialValue={updateDeployment}
        />
          :
          <CreateDeploymentForm
            onCancel={onClose}
          onSuccess={onSuccess}
          basePath={basePath}
          resourceAppId={resourceAppId}
          version={version}
          availableRegions={availableRegions}
        />}
      </Box>
    </Dialog>
  );
};

export default CreateDeploymentDialog;
